import { createFileRoute, notFound } from '@tanstack/react-router'
import { getStaticPage } from '@/src/lib/static-pages'
import { Markdown } from '@/src/components/Markdown'
import { NotFound } from '@/src/components/NotFound'
import { useTranslation } from '@/src/i18n/client'

export const Route = createFileRoute('/_static/privacy')({
  loader: () => {
    // Get both locales at build time for prerendering
    const enPage = getStaticPage('privacy', 'en')
    const dePage = getStaticPage('privacy', 'de')

    if (!enPage && !dePage) {
      throw notFound()
    }

    return { enPage, dePage }
  },
  head: ({ loaderData }) => ({
    meta: [
      { title: loaderData?.enPage?.title || 'Privacy Policy - GearLens' },
      { name: 'description', content: loaderData?.enPage?.description || 'Learn how GearLens collects, uses, and protects your personal information' }
    ],
  }),
  component: PrivacyPage,
})

function PrivacyPage() {
  const { i18n } = useTranslation()
  const { enPage, dePage } = Route.useLoaderData()

  // Select the appropriate page based on current locale
  const currentLocale = i18n.language.split('-')[0]
  const page = currentLocale === 'de' ? dePage : enPage

  if (!page) {
    return <NotFound />
  }

  return (
    <div className="container mx-auto max-w-7xl py-8">
      <Markdown
        content={page.content}
        className="prose prose-gray dark:prose-invert max-w-none"
      />
      {page.lastUpdated && (
        <p className="text-sm text-gray-500 dark:text-gray-400 mt-8">
          Last updated: {page.lastUpdated}
        </p>
      )}
    </div>
  )
}
